import React, { useEffect, useState } from 'react';
import {
  Box, Button, ButtonGroup, Card, CardContent, Checkbox, Divider, FormControl, FormControlLabel, Grid,
  LinearProgress, MenuItem, Radio, RadioGroup, Select, Stack, TextField, Typography, createFilterOptions
} from '@mui/material';
import { ClassNameMap, withStyles } from '@mui/styles';
import { toast } from 'react-toastify';
import { DatePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import Helper from '../../../../utils/helper';
import stylesheet from '../detail-container.stylesheet';
import { TaskService } from '../../../tasks/tasks.service';
import TaskHistoryComponent from '../../../tasks/task-history.component';

interface IProps {
  input: any,
  updateTaskData: any
  cancelTask: any
  classes: ClassNameMap
}

const AddTaskComponent: React.FC<IProps> = ({ input, updateTaskData, cancelTask, classes }) => {
  const [taskLoading, setTaskLoading] = useState(false) as any
  const [ownerList, setOwnerList] = useState(input.users || []) as any
  const taskService = new TaskService();
  const [latestTask, setLatestTask] = useState({}) as any
  const [picklistData, setPickListData] = useState({
    OwnerRole: {
      NAVIGATOR: "Navigator",
      PROVIDER: "Provider"
    }
  }) as any

  useEffect(() => {
    setOwnerList(input?.users?.filter((i: any) => i.role === 'navigator') || [])

    input.currTask.action === 'log_activity'
      ? setLatestTask({
        title: '',
        task_status: 'COMPLETED',
        action_type: 'Call',
        program_name: input.currTask.program_name,
        completion_date: input.currTask.date,
        patient_id: input.currTask.patient_id,
        note: '',
        //  owner_uuid: input.currTask.assignee_uuid
      })
      : setLatestTask({
        patient_id: input.currTask.patient_id,
        owner_uuid: '',//input.currTask.owner_uuid,
        tracking_type: 'Patient Specific',
        program_name: input.currTask.program_name,
        title: '',
        action_type: '',
        due_date: '',
        owner_role: 'Navigator',
        note: '',
      })
  }, [input.currTask])

  const updateTask = (e: React.ChangeEvent<HTMLInputElement>) => {
    const key = e.target.name === 'schedule' ? 'due_date' : [e.target.name] as any;
    if (e.target.name === 'owner_role') {
      setOwnerList(input?.users?.filter((i: any) => i.role.toLowerCase() === e.target.value.toLowerCase()) || [])
      setLatestTask({ ...latestTask, 'owner_uuid': '' })
    }

    setLatestTask({
      ...latestTask,
      [key]:
        e.target.name === 'action_type'
          ? input.currTask.action === 'log_activity'
            ? e.target.defaultValue
            : e.target.checked ? 'Call' : 'Other'
          : e.target.value
    })
  }

  const handleErr = (err: any) => {
    setTaskLoading(false)
    cancelTask()
    toast.error(Helper.getError(err), Helper.bottom_center())
  }

  const updateCurrTask = (res: any) => {
    setTaskLoading(false)
    if (res?.data?.task)
      updateTaskData(res?.data?.task)
    cancelTask()
  }

  const onSubmit = () => {
    setTaskLoading(true)
    let payload = Object.entries(latestTask)?.reduce((a: any, [k, v]) => (
      (v === undefined || v === '' || v === null || v === 'Invalid date')
        ? a : (a[k] = v, a)
    ), {})

    if (payload?.action_type !== 'Call' && input.currTask.action === 'Add')
      payload['action_type'] = 'Other'

    if (input.currTask.action === 'Add')
      payload = { ...payload, is_adhoc: true }

    if (payload?.owner_role) {
      const ownerRole = Object.keys(picklistData.OwnerRole)
        ?.filter((i: any) =>
          picklistData.OwnerRole[i] === payload.owner_role
        )[0] || payload.owner_role

      payload = { ...payload, owner_role: ownerRole }
    }

    if (input.currTask.note === latestTask.note)
      delete payload['note']

    if (latestTask?.due_date) {
      payload = {
        ...payload,
        'due_date': latestTask.due_date,
        'task_status': 'SCHEDULED_FOR_FUTURE',
      }
    }

    if (input.currTask.id) {
      taskService.putTaskSchedule(input.currTask.id, { ...payload, is_updated_today: true })
        .then((res: any) => {
          updateCurrTask(res)
        }).catch((err: any) => handleErr(err))
    } else {
      setTaskLoading(true)
      taskService.addPatientTask(payload).then((res: any) => {
        updateCurrTask(res)
      }).catch((err: any) => handleErr(err))
    }
  }

  return (
    <Box mb={1} className={classes.customCard}>
      <Card variant="outlined"
        sx={{
          width: input.isTaskPanel
            ? '100%'
            : input.currTask.action === 'edit'
              ? '74%'
              : input.currTask.patient_id ? '50%' : '60%'
        }}
        onKeyUp={(e: any) => {
          e.preventDefault();
          if (e.key === 'Enter' && latestTask.title !== '' && e?.target?.name !== 'note')
            onSubmit()
        }}
      >
        {taskLoading && <LinearProgress sx={{ paddingTop: '-10px' }} />}

        <CardContent sx={{ padding: '0.5rem 0.5rem 0.5rem 1rem' }}>
          <Typography variant="subtitle2">
            {`${input.currTask.action === 'log_activity'
              ? 'Log activity'
              : input.currTask.action === 'edit' ? 'Update task' : 'Add task'
              }`}
          </Typography>
          <Stack direction={'row'} spacing={1} justifyContent={'space-between'}>
            <Stack direction={'column'} spacing={0.8} sx={{ width: '25rem' }} >
              <TextField
                id="outlined-basic"
                variant="standard"
                placeholder='Title'
                autoFocus
                name="title"
                size="small"
                value={latestTask.title}
                inputProps={{ style: { fontSize: '0.7rem' } }}
                InputLabelProps={{ style: { fontSize: '0.7rem' } }}
                className={classes.fullWidth}
                rows="1"
                onChange={updateTask}
              />
              <TextField
                id="outlined-basic"
                name="note"
                variant="outlined"
                placeholder="Add note here"
                size="small"
                value={latestTask?.note}
                inputProps={{ style: { fontSize: '0.7rem' } }}
                InputLabelProps={{ style: { fontSize: '0.7rem' } }}
                className={classes.fullWidth}
                multiline={true}
                rows="6"
                onChange={(e: any) => updateTask(e)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    padding: '0.2rem 0rem 0.2rem 0.5rem !important',
                  }
                }}
              />
              {input.currTask.action === 'log_activity'
                ? <Stack direction={'row'} spacing={2} alignItems={'center'} pl={0.2} pb={0.3}>
                  <Typography className={classes.taskInput}>Activity type: </Typography>
                  <FormControl>
                    <RadioGroup
                      row
                      defaultValue={'Call'}
                      value={latestTask.action_type}
                      name="action_type"
                      sx={{
                        '.MuiRadio-root': {
                          padding: '0px 2px 0px 0px !important'
                        }
                      }}
                      onChange={updateTask}
                    >
                      <FormControlLabel value="Call" control={<Radio size='small' />}
                        label={<Typography className={classes.taskInput}>Call</Typography>}
                      />
                      <FormControlLabel sx={{ paddingLeft: '0.25rem' }} value="Other" control={<Radio size='small' />}
                        label={<Typography className={classes.taskInput}>Other</Typography>}
                      />
                    </RadioGroup>
                  </FormControl>
                </Stack>
                : <Stack direction={'row'} spacing={0} pl={0.9} sx={{ marginTop: '0rem !important' }}>
                  <FormControlLabel
                    control={
                      <Checkbox size="small"
                        sx={{ padding: '0rem !important', transform: "scale(0.6)", }}
                        name='action_type'
                        checked={latestTask.action_type === 'Call'}
                        onChange={updateTask}
                      />
                    }
                    label={<Typography pt={0} className={classes.taskInput}>Call</Typography>}
                  />
                  <Stack direction={'row'} spacing={0.4} alignItems={'baseline'}>
                    <Typography className={classes.taskInput}>Owner Role:</Typography>
                    <Select
                      variant="standard"
                      value={latestTask?.owner_role || 'Navigator'}
                      name="owner_role"
                      onChange={(e: any) => updateTask(e)}
                      className={classes.nextActionSelect}
                      inputProps={{ 'aria-label': 'select role', }}
                      sx={{
                        width: '5.1rem !important',
                        '&.MuiInput-root': {
                          padding: '0.2rem !important'
                        }
                      }}
                    >
                      {Object.values(picklistData.OwnerRole)?.map((i: any) => (
                        <MenuItem className={classes.taskInput} value={i}>{i}</MenuItem>
                      ))}
                    </Select>
                  </Stack>
                </Stack>
              }
              {input.currTask.action !== 'log_activity' &&
                <Box sx={{ marginTop: '-0.2rem !important', paddingLeft: '0.1rem' }}>
                  <Typography className={classes.taskInput}>Owner</Typography>
                  <Select
                    name={`owner_uuid`}
                    variant="standard"
                    margin="dense"
                    label={'Owner'}
                    value={latestTask.owner_uuid}
                    onChange={(e: any) => updateTask(e)}
                    inputProps={{ classes: { icon: classes.icon }, }}
                    sx={{
                      width: '6rem',
                      paddingTop: '0rem !important',
                      '.MuiSvgIcon-root': { fontSize: '0.8rem' },
                      '&.MuiInput-root': { padding: '0rem !important' }
                    }}
                  >
                    {ownerList?.map((item: any) =>
                      <MenuItem
                        key={item}
                        className={classes.taskInput}
                        value={item?.id}
                        selected={item?.id === latestTask.owner_uuid}
                      >
                        {item?.name}
                      </MenuItem>
                    )}
                  </Select>
                  <Box sx={{ marginTop: '0.5rem !important' }}>
                    <Typography className={classes.taskInput}>Due date</Typography>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DatePicker
                        className={classes.taskSchedule}
                        name={'schedule'}
                        format={'MM/DD/YYYY'}
                        formatDensity="dense"
                        disablePast
                        slotProps={{ textField: { size: 'small', error: false } }}
                        value={moment(moment(latestTask.due_date, 'YYYY-MM-DD'), 'MM/DD/YYYY')}
                        onChange={(val: any) => setLatestTask({
                          ...latestTask,
                          due_date: moment(val).format('YYYY-MM-DD')
                        })
                        }
                      />
                    </LocalizationProvider>
                  </Box>
                </Box>
              }
              <Box pt={0.5}>
                <ButtonGroup className={classes.questionFullButtonStyle} size="small" variant="text">
                  <Button className={classes.twoButtonWidth}
                    disabled={taskLoading ||
                      (input.currTask.action === 'log_activity' &&
                        (latestTask.title === '' || latestTask.action_type === '')) ||
                      (input.currTask.action !== 'log_activity' && latestTask.title === '')
                    }
                    onClick={() => onSubmit()}
                  >
                    <strong>{`Submit`}</strong>
                  </Button>
                  <Button onClick={() => cancelTask()} className={classes.twoButtonWidth}>
                    <strong> {'Cancel'}</strong>
                  </Button>
                </ButtonGroup>
              </Box>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  )
}

export default withStyles(stylesheet)(AddTaskComponent);